import Marquee from "react-fast-marquee";
import { formatGram } from "@/lib/options";

const Item = ({ label, value, sub }) => (
  <div
    className="flex items-baseline gap-3 px-8"
    data-testid={`ticker-item-${label.toLowerCase()}`}
  >
    <span className="overline">{label}</span>
    <span className="font-serif text-base text-charcoal-900">
      {value}
    </span>
    {sub ? (
      <span className="text-xs text-charcoal-400">{sub}</span>
    ) : null}
  </div>
);

export default function PriceTicker({ prices, loading }) {
  const items = prices
    ? [
        { label: "Gold (XAU)", value: formatGram(prices.XAU_per_g), sub: "per gram, spot" },
        { label: "Silver (XAG)", value: formatGram(prices.XAG_per_g), sub: "per gram, spot" },
        { label: "Platinum (XPT)", value: formatGram(prices.XPT_per_g), sub: "per gram, spot" },
        { label: "Source", value: "metalpriceapi.com", sub: "live mid-market" },
      ]
    : [];

  return (
    <div
      className="w-full border-y border-zinc-200 bg-champagne-100/60"
      data-testid="live-price-ticker"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        {loading || !prices ? (
          <div className="overline text-charcoal-400" data-testid="ticker-loading">
            Fetching live spot prices…
          </div>
        ) : (
          <Marquee gradient={false} speed={32} pauseOnHover>
            <div className="flex items-center pl-8">
              {items.concat(items).map((it, i) => (
                <div key={i} className="flex items-center">
                  <Item label={it.label} value={it.value} sub={it.sub} />
                  <span className="text-champagne-400">·</span>
                </div>
              ))}
            </div>
          </Marquee>
        )}
      </div>
    </div>
  );
}
